import React, { useContext } from 'react';
import { MembershipContext } from '../../../../context/MembershipProvider';
import { LabelLarge } from '@styled';

const MembershipSearchStatusText = () => {
    const { searchStatus, user } = useContext(MembershipContext);
    const welcomeBackText = user && user.firstName ? `, ${user.firstName}!` : '!';

    return (
        <div>
            {searchStatus === 'emailNotFound' && (
                <LabelLarge>We can't find your email in our system. Please enter your first & last name.</LabelLarge>
            )}
            {searchStatus === 'login' && (
                <LabelLarge className="bold mt-4">Welcome back{welcomeBackText} Please enter your password.</LabelLarge>
            )}
            {searchStatus === 'nameNotFound' && (
                <LabelLarge className="bold mt-4">
                    We can't find your name in our system. Please create an account to continue.
                </LabelLarge>
            )}
        </div>
    );
};

MembershipSearchStatusText.propTypes = {};

export default MembershipSearchStatusText;
